import {redirectDocument} from 'react-router-dom';

const localSSOUrl = 'http://localhost:5174';
const prodSSOUrl = 'https://ethics-platform.com';

export const redirectToLogin = () =>
  redirectDocument(import.meta.env.DEV ? localSSOUrl : prodSSOUrl);
